import { RouteObject } from "react-router-dom";
import AddNetwork from "./components/create/create";
import NetworkDetail from "./components/Details/DetailsLanding";
import Landing from "./components/Landing";

export interface networksRoutes extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: networksRoutes[];
}

export const networksRoutes: networksRoutes[] = [
  {
    path: "/ax/asset-registry/networks",
    element: <Landing />,
  },
  {
    path: "/ax/asset-registry/networks/create/:action",
    element: <AddNetwork />,
  },
  {
    path: "/ax/asset-registry/networks/create/:action/:id",
    element: <AddNetwork />,
  },

  {
    path: "/ax/asset-registry/networks/view/:id",
    element: <NetworkDetail />,
  },
];
